import client from '../../../api'
import type { RequestConfig, ResponseErrorConfig } from '../../../api'
import type {
  SchoolsControllerEnableCashbackMutationRequest,
  SchoolsControllerEnableCashbackMutationResponse,
  SchoolsControllerEnableCashbackPathParams,
} from '../../ts/schoolsDTO/SchoolsControllerEnableCashback'

export function getSchoolsControllerEnableCashbackUrl({ schoolId }: { schoolId: SchoolsControllerEnableCashbackPathParams['schoolId'] }) {
  return `/schools/${schoolId}/toggle-cashback` as const
}

/**
 * @summary Активация кешбека для школы
 * {@link /schools/:schoolId/toggle-cashback}
 */
export async function schoolsControllerEnableCashback(
  { schoolId }: { schoolId: SchoolsControllerEnableCashbackPathParams['schoolId'] },
  data: SchoolsControllerEnableCashbackMutationRequest,
  config: Partial<RequestConfig<SchoolsControllerEnableCashbackMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<SchoolsControllerEnableCashbackMutationResponse, ResponseErrorConfig<Error>, SchoolsControllerEnableCashbackMutationRequest>({
    method: 'PATCH',
    url: getSchoolsControllerEnableCashbackUrl({ schoolId }).toString(),
    data,
    ...requestConfig,
  })
  return res
}